import React from 'react';
import Questionnaire from './Questionnaire';

function Index() {
  return (<Questionnaire  />);
}

export default Index;